// extracted by mini-css-extract-plugin
export default {"news__item":"NewsItem_news__item__XlTgk","news__promo":"NewsItem_news__promo__NTDEa","news__link":"NewsItem_news__link__YmpfM"};